import HttpFactory from '@/mixins/http.factory';
export default {
	name:'enable-syncing',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
		}
	},
	created(){
		//this.init();
	},
	mounted(){
		const _self=this;
		//_self.hideIframe('iframe1')
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');
		},
		showNotFoundError(msg){
			let _self=this;
			_self.userMsg={show:true,type:'danger',list:[msg]};
		},
		hideIframe(iframeId){
			if(document.getElementById(iframeId)==null){
				this.hideIframe(iframeId);
				return;
			}
			document.getElementById(iframeId).onload = function() {
				var iframe = document.getElementById(iframeId);
				
				var headerElem = iframe.contentWindow.document.getElementsByTagName("header")[0];
				headerElem.style.display = "none";
				
				var searchElem = iframe.contentWindow.document.getElementsByClassName("aa")[0];
				searchElem.style.display = "none";

				var navBar = iframe.contentWindow.document.getElementsByTagName("column--sm-4")[0];
				navBar.style.display = "none";

				var mainContent = iframe.contentWindow.document.getElementsByTagName("column--sm-8")[0];
				if(mainContent){
					mainContent.className = "column--sm-12";
				}
				//$(iframeId).contents().find('header').hide();
				//$(iframeId).contents().find('.ly .aa').hide();
				//$(iframeId).contents().find('.column.column--sm-4').hide();
				//$(iframeId).contents().find('.column.column--sm-8').hide();
			};
		}
	}
}

